import React from 'react';
import Icon from '../Icon';
import { SC_IMAGES } from '../../data/images';

const ProblemItem = ({ icon, title, body }) => (
  <div className="problem-item reveal">
    <div className="ic-wrap"><Icon name={icon} size={22} stroke={1.8} /></div>
    <div>
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  </div>
);

const Problem = () => (
  <section className="section-problem" id="problem">
    <div className="container">
      <div className="problem-grid">
        <div>
          <div className="section-head" style={{ marginBottom: 0 }}>
            <span className="eyebrow eyebrow-gold">The unseen work</span>
            <h2 className="section-title">
              Caring for someone you love is a full-time job. <em style={{ color: 'var(--ink-mute)', fontStyle: 'italic' }}>It shouldn't be invisible.</em>
            </h2>
          </div>
          <div className="problem-list">
            <ProblemItem icon="utensils" title="Cooking, feeding, planning meals" body="Three meals a day, every day — adapted for diet, allergies, or what they'll actually eat that morning." />
            <ProblemItem icon="pill" title="Medications and appointments" body="Sorting pills, tracking refills, sitting in waiting rooms, calling pharmacies on hold." />
            <ProblemItem icon="walking" title="Bathing, dressing, mobility" body="Helping them up, helping them down, helping them feel like themselves at the end of a long day." />
            <ProblemItem icon="brain" title="Memory and supervision" body="Watching for the stove left on, the door left open, the name they forgot mid-sentence." />
          </div>
        </div>

        <aside className="problem-pull">
          <div className="problem-pull-photo" style={{ backgroundImage: `linear-gradient(180deg, rgba(14,42,57,0) 30%, rgba(14,42,57,.7) 100%), url(${SC_IMAGES.problem})` }} />
          <div className="pull-eyebrow">What most people miss</div>
          <h3>
            Federal and state programs already pay family members to provide this care.
            Most people don't know they exist.
          </h3>
          <p>
            Programs like Medicaid Self-Directed Care, In-Home Supportive Services (IHSS),
            and Veteran-Directed Care exist in all 50 states — but the paperwork,
            eligibility rules, and approval process keep most families away.
          </p>
          <p style={{ marginTop: 18, color: 'var(--gold)' }}>
            <strong>That's the gap we close.</strong>
          </p>
        </aside>
      </div>
    </div>
  </section>
);

export default Problem;
